<template>
  <div class="mb-3">
    <div class="d-flex align-items-center mb-2">
      <label :for="id" class="form-label me-2 mb-0">{{ label }}</label>
      <button @click.prevent="handleSearch" class="btn btn-sm btn-outline-secondary text-nowrap">住所を検索</button>
    </div>
    <input v-model="postalCodeLocal" type="text" :id="id" class="form-control" :placeholder="placeholder">
    <div v-if="postalCodeError" class="alert alert-warning mt-2">{{ postalCodeError }}</div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Core as YubinBangoCore } from 'yubinbango-core2';

const props = defineProps({
  modelValue: String,
  label: { type: String, default: '郵便番号' },
  id: { type: String, default: 'postalCode' },
  placeholder: { type: String, default: '郵便番号' }
});
const emit = defineEmits(['update:modelValue', 'address']);

const postalCodeLocal = ref(props.modelValue);
watch(() => props.modelValue, (val) => {
  postalCodeLocal.value = val;
});
watch(postalCodeLocal, (val) => {
  emit('update:modelValue', val);
});

const postalCodeError = ref('');

const handleSearch = () => {
  const zip = postalCodeLocal.value?.replace(/[^\d]/g, '');
  if (!zip) {
    postalCodeError.value = '郵便番号を入力してください';
    return;
  }
  if (zip.length !== 7) {
    postalCodeError.value = '郵便番号は7桁の数字で入力してください';
    return;
  }
  postalCodeError.value = '';
  new YubinBangoCore(zip, (res) => {
    if (!res.region && !res.locality && !res.street) {
      postalCodeError.value = '存在しない郵便番号です';
      emit('address', { region: '', locality: '', street: '' });
      return;
    }
    emit('address', {
      region: res.region || '',
      locality: res.locality || '',
      street: res.street || ''
    });
  });
};
</script>
